import React from 'react'
import Story from './Story/Story'

export const Home = () => {
  return (
    <div className="container-xl px-4">
      <Story/>
    </div>
  )
}